// extracted by mini-css-extract-plugin
export default {"detailWrapper":"Recipe_detailWrapper__E9DBU","image":"Recipe_image__ERTvy"};